<h1 matDialogTitle>{{data.title}}</h1>

<mat-dialog-content>

  <ng-container *ngIf="integrationBusy; else integrationDone">
    <div style="text-align: center;margin: 16px;">
      Busy generating your document, please wait ...
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
  <ng-template #integrationDone>
    <div style="background-color: #f31700a1;padding: 16px;border-radius: 5px;">
     {{printTrigger?.errorMessage}}
    </div>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [disabled]="integrationBusy" matDialogClose>Close</button>
</mat-dialog-actions>
